import * as React from "react";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";

import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";

import ModeEditIcon from "@mui/icons-material/ModeEdit";
import DeleteIcon from "@mui/icons-material/Delete";

import dayjs from "dayjs";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

export default function ViewDialog({ open, onClose, selected, onDelete }) {
  //   const [row1, setRow1] = React.useState(selected);

  //   const handleClickOpen = () => {
  //     setOpen(true);
  //   };
  //   const handleDelete = () => {
  //     onDelete(selected);
  //   };

  return (
    <div>
      {/* <Button variant="outlined" onClick={handleClickOpen}>
        Open dialog
      </Button> */}
      <BootstrapDialog
        onClose={onClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        maxWidth="md"
        fullWidth
      >
        <BootstrapDialogTitle id="customized-dialog-title" onClose={onClose}>
          Detalii Programare
        </BootstrapDialogTitle>
        <DialogContent dividers>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <TextField
                margin="dense"
                id="id"
                label="ID Programare"
                fullWidth
                disabled={true}
                value={selected ? selected._id : ""}
                variant="standard"
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                margin="dense"
                id="id"
                disabled={true}
                label="Adaugata in"
                fullWidth
                value={
                  selected
                    ? dayjs(selected?.createdAt).format("DD MMMM YYYY HH:mm")
                    : ""
                }
                variant="standard"
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                margin="dense"
                id="id"
                disabled={true}
                label="Modificat in"
                fullWidth
                value={
                  selected
                    ? dayjs(selected?.updatedAt).format("DD MMMM YYYY HH:mm")
                    : ""
                }
                variant="standard"
              />
            </Grid>
          </Grid>
          <Typography sx={{ my: 3 }}> </Typography>
          {/* <Typography sx={{ mt: 3 }}> Detalii Provider</Typography> */}
          <Grid container spacing={2}>
            <Grid item xs={4}>
              <TextField
                margin="dense"
                id="id"
                InputProps={{
                  readOnly: true,
                }}
                label="Service"
                fullWidth
                value={selected ? selected.doctor.specialitate : ""}
                // variant="standard"
              />
            </Grid>

            <Grid item xs={4}>
              <TextField
                margin="dense"
                id="id"
                InputProps={{
                  readOnly: true,
                }}
                label="Doctor"
                fullWidth
                value={selected ? selected.doctor.name : ""}
                // variant="standard"
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                margin="dense"
                id="id"
                InputProps={{
                  readOnly: true,
                }}
                label="Status"
                fullWidth
                value={selected ? selected.status : ""}
                // variant="standard"
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                margin="dense"
                id="id"
                InputProps={{
                  readOnly: true,
                }}
                label="Data Programarii"
                fullWidth
                value={
                  selected
                    ? dayjs(selected.start_time).format("DD MMMM YYYY")
                    : ""
                }
                // variant="standard"
              />
            </Grid>

            <Grid item xs={4}>
              <TextField
                margin="dense"
                id="id"
                InputProps={{
                  readOnly: true,
                }}
                label="Start"
                fullWidth
                value={
                  selected ? dayjs(selected.start_time).format("HH:mm") : ""
                }
                // variant="standard"
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                margin="dense"
                id="id"
                InputProps={{
                  readOnly: true,
                }}
                label="End"
                fullWidth
                value={selected ? dayjs(selected.end_time).format("HH:mm") : ""}
                // variant="standard"
              />
            </Grid>
          </Grid>
          <Typography sx={{ my: 3 }}> Detalii Pacient</Typography>
          <Grid container spacing={2}>
            <Grid item xs={4}>
              <TextField
                margin="dense"
                id="id"
                InputProps={{
                  readOnly: true,
                }}
                label="Nume Pacient"
                fullWidth
                value={selected ? selected.p_name : ""}
                // variant="standard"
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                margin="dense"
                id="id"
                InputProps={{
                  readOnly: true,
                }}
                label="Telefon Pacient"
                fullWidth
                value={selected ? selected.p_phone : ""}
                // variant="standard"
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                margin="dense"
                id="id"
                InputProps={{
                  readOnly: true,
                }}
                label="Email Pacient"
                fullWidth
                value={selected ? selected.p_email : ""}
                // variant="standard"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                margin="dense"
                multiline
                rows={3}
                id="id"
                disabled={true}
                InputProps={{
                  readOnly: true,
                }}
                label="Notite"
                fullWidth
                value={selected ? selected.notes : ""}
                variant="standard"
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <Button
            onClick={() => onDelete(selected)}
            color="error"
            startIcon={<DeleteIcon />}
          >
            Delete
          </Button>
          <Button onClick={onClose} startIcon={<ModeEditIcon />}>
            Edit
          </Button>
        </DialogActions>
      </BootstrapDialog>
    </div>
  );
}
